import { render, staticRenderFns } from "./PrototypeComplete.vue?vue&type=template&id=5cef58af&scoped=true"
import script from "./PrototypeComplete.vue?vue&type=script&lang=js"
export * from "./PrototypeComplete.vue?vue&type=script&lang=js"
import style0 from "./PrototypeComplete.vue?vue&type=style&index=0&id=5cef58af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cef58af",
  null
  
)

export default component.exports